import {filter} from "lodash"

import authentication from "@irati/auth"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"
import usersToString from "./usersToString"

export const recognitionUsersToStringTitle = (receivers, formatMessage) => {
  const you = filter(receivers, (test) => test.uuid === authentication.user().uuid)[0]

  if (you) {
    const others = filter(receivers, (test) => test.uuid !== authentication.user().uuid)
    return usersToString(you, others, formatMessage)
  }
  if (receivers) {
    if (receivers.length === 1) {
      return formatMessage(
        {id: "recognition.utils.recognitionUsersToString.oneRecognised.title"},
        {recognisedName: firstnameLastname(receivers[0])}
      )
    }
    if (receivers.length === 2) {
      return formatMessage(
        {id: "recognition.utils.recognitionUsersToString.twoRecognised.title"},
        {recognisedNameOne: firstnameLastname(receivers[0]), recognisedNameTwo: firstnameLastname(receivers[1])}
      )
    }
    if (receivers.length === 3) {
      return formatMessage(
        {id: "recognition.utils.recognitionUsersToString.threeRecognised.title"},
        {
          recognisedNameOne: firstnameLastname(receivers[0]),
          recognisedNameTwo: firstnameLastname(receivers[1]),
          recognisedNameThree: firstnameLastname(receivers[2])
        }
      )
    }
    if (receivers.length > 3) {
      return formatMessage({id: "recognition.utils.usersToString.fourOrMore.title"}, {nbOfUsers: receivers.length})
    }
  }
}

export const recognitionUsersToStringSubtitle = (receivers, recogniserName, formatMessage) => {
  const you = filter(receivers, (test) => test.uuid === authentication.user().uuid)[0]

  if (you) {
    const others = filter(receivers, (test) => test.uuid !== authentication.user().uuid)
    if (others.length === 0) {
      return formatMessage({id: "recognition.utils.recognitionUsersToString.youSingleRecognised.subtitle"}, {recogniserName})
    }
    return formatMessage({id: "recognition.utils.recognitionUsersToString.youMultipleRecognised.subtitle"}, {recogniserName})
  }

  if (receivers.length === 1) {
    return formatMessage({id: "recognition.utils.recognitionUsersToString.otherSingleRecognised.subtitle"}, {recogniserName})
  }

  return formatMessage({id: "recognition.utils.recognitionUsersToString.otherMultipleRecognised.subtitle"}, {recogniserName})
}
